import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { Typography } from '@mui/material';
import ModalFormWrapper from '@sharedCR/coreDesignSystem/ModalFormWrapper';
import Skeleton from 'app/shared/components/common/Skeleton';
import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';

import { SKELETON_TYPES } from 'constants/skeleton';
import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import { getApplicationContactsAction } from 'store/loanApplications/actions';
import { selectApplicationCallContacts } from 'store/loanApplications/selectors';

import ContactRow from './ContactRow';

const ContactsModal = ({ isLoading, setIsLoading }) => {
  const dispatch = useDispatch();

  const { applicationId } = useParams();

  const contacts = useSelector(selectApplicationCallContacts);

  useEffectSafeStrictMode(() => {
    setIsLoading(true);
    dispatch(getApplicationContactsAction({ applicationId }))
      .catch(Error)
      .finally(() => setIsLoading(false));
  }, [applicationId, dispatch, setIsLoading]);

  if (isLoading) {
    return <Skeleton length={3} type={SKELETON_TYPES.LIST} />;
  }

  if (!contacts.length) {
    return (
      <Typography className="m-80" color="textSecondary" variant="regular14">
        No contacts for this application
      </Typography>
    );
  }

  // TODO: get rid of ModalFormWrapper, make custom modal for this case without form
  return (
    <ModalFormWrapper isFormChanged cancelButtonName="Close" formTestId="contacts-modal-form">
      {contacts.map((contact, index) => (
        <ContactRow applicationId={applicationId} key={index} {...contact} />
      ))}
    </ModalFormWrapper>
  );
};

ContactsModal.propTypes = {
  ...WithLoadingPropTypes,
};

export default withLoading(ContactsModal);
